'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _OMBaseMultiPinCell = require('./OMBaseMultiPinCell/OMBaseMultiPinCell');var _OMBaseMultiPinCell2 = _interopRequireDefault(_OMBaseMultiPinCell);

var _parkingConverter = require('../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var OMMultiPinCell = function (_Component) {_inherits(OMMultiPinCell, _Component);function OMMultiPinCell() {var _temp, _this, _ret;_classCallCheck(this, OMMultiPinCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.


















    openDetails = function (evt) {
      evt.stopPropagation();
      var route = (0, _appendLocale2.default)(_this.props.locale, '/home_details/' + _this.props.id);

      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        if (_this.props.suppressLoading && _this.props.setPreloadData) {
          _this.props.suppressLoading(true).
          then(_this.props.setPreloadData(_this.generatePreloadData())).
          then(function () {return _reactRouter.browserHistory.push(route);});
        } else {
          _reactRouter.browserHistory.push(route);
        }
      } else {
        _this.openDetailsPopup();
      }
    }, _this.

    openDetailsPopup = function () {
      _this.props.openDetailsPopup(_this.generatePreloadData());
      (0, _analyticsManager.trackModalOpen)('property/' + _this.props.id);
    }, _this.

    generatePreloadData = function () {return {
        propertyId: _this.props.id,
        address: _this.props.addressData,
        price: _this.props.price,
        additionalInfo: {
          area: _this.props.area,
          floor: _this.props.floor === 0 ?
          _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut').toString() :
          _this.props.floor,
          parkingSpots: (0, _parkingConverter2.default)(_this.props.parkingSpots),
          rooms: _this.props.rooms },

        propertyType: _this.props.propertyType,
        optionType: _this.props.optionType };}, _this.


    createRef = function (ref) {
      _this.multiPinCell = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);}OMMultiPinCell.prototype.componentDidMount = function componentDidMount() {if (this.multiPinCell) {this.multiPinCell.addEventListener('click', this.openDetails, true);}};OMMultiPinCell.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {var isIdChanged = newProps.id !== this.props.id;var isLocaleChanged = newProps.locale !== this.props.locale;return isIdChanged || isLocaleChanged;};OMMultiPinCell.prototype.componentWillUnmount = function componentWillUnmount() {if (this.multiPinCell) {this.multiPinCell.removeEventListener('click', this.openDetails, true);}};OMMultiPinCell.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', {
          vocab: 'http://schema.org/',
          'typeof': 'Apartment',
          ref: this.createRef },

        _react2.default.createElement(_OMBaseMultiPinCell2.default, {
          locale: this.props.locale,
          isMobile: this.props.isMobile,
          isRtl: this.props.isRtl,
          id: this.props.id,
          propertyType: this.props.propertyType,
          photo: this.props.photo,
          price: this.props.price,
          address: this.props.address,
          rooms: this.props.rooms,
          parkingSpots: this.props.parkingSpots,
          city: this.props.city,
          area: this.props.area,
          floor: this.props.floor,
          isNewProperty: this.props.isNewProperty,
          hasVRLink: this.props.hasVRLink,
          parkingIconTitle: this.props.translate('iconTitles', 'parkingIcon'),
          roomsIconTitle: this.props.translate('iconTitles', 'roomsIcon'),
          floorIconTitle: this.props.translate('iconTitles', 'floorIcon'),
          squareIconTitle: this.props.translate('iconTitles', 'squareIcon'),
          groundFloorTitle: this.props.translate('propertyDetails', 'details', 'groundFloorShortcut'),
          newPropertyTitle: this.props.translate('iconTitles', 'newPropertyTitle'),
          newPropertyLabel: this.props.translate('iconTitles', 'newPropertyLabel'),
          status: this.props.status,
          translate: this.props.translate,
          propertyEntityType: this.props.propertyEntityType,
          searchOption: this.props.searchOption })));



  };return OMMultiPinCell;}(_react.Component);


OMMultiPinCell.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  price: _propTypes2.default.number,
  address: _propTypes2.default.string,
  rooms: _propTypes2.default.number,
  parkingSpots: _propTypes2.default.object,
  city: _propTypes2.default.string,
  cityEn: _propTypes2.default.string,
  area: _propTypes2.default.number,
  floor: _propTypes2.default.number,
  addressData: _propTypes2.default.object,
  propertyType: _propTypes2.default.string,
  propertyNote: _propTypes2.default.string,
  isFavorite: _propTypes2.default.bool,
  isPromoted: _propTypes2.default.bool,
  hasVRLink: _propTypes2.default.bool,
  optionType: _propTypes2.default.string,
  isNewProperty: _propTypes2.default.bool,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  onHover: _propTypes2.default.func,
  setPreloadData: _propTypes2.default.func,
  suppressLoading: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  status: _propTypes2.default.string,
  propertyEntityType: _propTypes2.default.string,
  searchOption: _propTypes2.default.string };exports.default =


OMMultiPinCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMMultiPinCell.js
// module id = 2748
// module chunks = 0